module.exports = __webpack_public_path__ + "img/ic_nat_home_record.c0b16019.png";